const sm = '600px';
const md = '990px';
const lg = '1280px';
const xl = '1680px';

export const screenBreakpoints = {
  sm,
  md,
  lg,
  xl,
};
